import { useTheme } from "@/app/providers/theme-provider"
import { SmallLogo } from "@/customer/small-logo"
import { getInjectedAsset } from "@/lib/runtime-branding"

/**
 * The avatar beside assistant messages.
 *
 * An uploaded assistant avatar (#3227) wins; it is shown whole, not cropped
 * to a circle, because it is usually a transparent brand mark chosen for this
 * size. Without one the chat shows the small logo in a circle, as before.
 * Light and dark fall back to each other, like the logos.
 */
export function AssistantAvatar() {
  const { theme } = useTheme()
  const isDark =
    theme === "system"
      ? window.matchMedia("(prefers-color-scheme: dark)").matches
      : theme === "dark"

  const light = getInjectedAsset("assistant_avatar_light")
  const dark = getInjectedAsset("assistant_avatar_dark")
  const avatar = isDark ? (dark ?? light) : (light ?? dark)
  if (avatar) {
    return <img alt="" className="size-8 object-contain" src={avatar.url} />
  }
  return <SmallLogo className="size-8 rounded-full" />
}
